import { useContext } from "react";
import { UserContext } from "../amplify/authenticator-provider";

const hasDocument = typeof document !== "undefined";
const vendorEvents = [
  {
    hidden: "hidden",
    event: "visibilitychange",
    state: "visibilityState",
  },
  {
    hidden: "webkitHidden",
    event: "webkitvisibilitychange",
    state: "webkitVisibilityState",
  },
  {
    hidden: "mozHidden",
    event: "mozvisibilitychange",
    state: "mozVisibilityState",
  },
  {
    hidden: "msHidden",
    event: "msvisibilitychange",
    state: "msVisibilityState",
  },
  {
    hidden: "oHidden",
    event: "ovisibilitychange",
    state: "oVisibilityState",
  },
];

export const isSupported = hasDocument && Boolean(document.addEventListener);

export const visibility = (() => {
  if (!isSupported) {
    return null;
  }
  for (let i = 0; i < vendorEvents.length; i++) {
    const event = vendorEvents[i];
    if (event.hidden in document) {
      return event;
    }
  }
  // otherwise it's not supported
  return null;
})();

export const getVisibilityState = ({ hidden, state }) => {
  return {
    documentHidden: document[hidden],
    visibilityState: document[state],
  };
};

export const getHandlerArgs = () => {
  const { hidden, state } = visibility;
  return [!document[hidden], document[state]];
};

export const getCognitoRoles = accessTokenPayload =>
  accessTokenPayload && accessTokenPayload["cognito:groups"]
    ? accessTokenPayload["cognito:groups"]
    : false;

// EAI-1486: effective roles for UI routing/gating. The Cognito token stays
// ADMIN throughout impersonation (we don't re-mint it), so admin-only
// redirects and nav gates would otherwise trap the session on the admin
// dashboard and hide the target's app. While impersonating, report the
// session as NON-admin so the UI mirrors the target — the backend already
// enforces the target's real permissions on every request.
export const getEffectiveCognitoRoles = accessTokenPayload => {
  if (typeof window !== "undefined" && sessionStorage.getItem("impersonateUserId")) {
    return false;
  }
  return getCognitoRoles(accessTokenPayload);
};

export const isPlatformAdmin = authData => {
  const cognitoRoles = getEffectiveCognitoRoles(authData?.signInUserSession?.accessToken?.payload);
  return cognitoRoles ? cognitoRoles[0] === "ADMIN" : false;
};
export const usePlatformAdmin = () => {
  const { authData } = useContext(UserContext);
  const cognitoRoles = getEffectiveCognitoRoles(authData?.signInUserSession?.accessToken?.payload);
  return cognitoRoles?.[0] === "ADMIN";
};
